import $ from 'jquery'
import '@toolkit/vendor/javascripts/modernizr.slim'

$(function () {
  let closeActiveDropdown = null

  $('body').on('click', '.dropdown--toggle', function (e) {
    // Close currently active dropdown
    if (closeActiveDropdown) {
      closeActiveDropdown()
      closeActiveDropdown = null
    }

    e.preventDefault()

    let closeTimeout = null
    const $toggle = $(this)
    const $dropdown = $toggle.closest('.dropdown')
    const isOpen = $dropdown.hasClass('s-open')
    const close = function () {
      $dropdown.off('mouseout.dropdown mouseover.dropdown')
      $dropdown.removeClass('s-open')
      $toggle.attr('aria-expanded', false)
      clearTimeout(closeTimeout)
    }

    closeActiveDropdown = close

    if (!isOpen) {
      $dropdown.addClass('s-open')
      $toggle.attr('aria-expanded', true)
      $(document).one('click', close)

      if (!window.Modernizr.touchevents) {
        $dropdown.on('mouseout.dropdown', function () {
          closeTimeout = setTimeout(close, 1500)
        })
        $dropdown.on('mouseover.dropdown', function () {
          clearTimeout(closeTimeout)
        })
      }
      e.stopPropagation()
    }
  })
})
